export default __webpack_public_path__ + "static/media/e-hamburger-black.9159dc51.svg";